"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashedString = void 0;
const crypto_js_1 = __importDefault(require("crypto-js"));
/**
 * Hashed string
 * @param value
 * @returns
 */
const hashedString = (value) => {
    if (value && typeof value !== 'undefined' && typeof value === 'string') {
        return crypto_js_1.default.SHA1(value).toString();
    }
    return undefined;
};
exports.hashedString = hashedString;
//# sourceMappingURL=hashing.js.map